import { getCookie } from '../../common/utils'
import { SINGLE_ORDER_MAX_NUM } from '../../common/saleConfig'

export function cartAjax(opts){
    const {path, type = 'POST', data, success, error, ...others} = opts;
    const _data = type.toLowerCase() === 'post' ? {csrf_token: getCookie('csrf_token'), ...data} : data
    $.ajax({
        url: '//api-content.onethingcloud.com/cn/'+path,
        type,
        data: _data,
        success: success || function(result){
            console.log(result);
        },
        error: error || function(err) {
            console.log(err);
        },
        crossDomain: true,
        xhrFields: { withCredentials: true },
        cache: false,
        ifModified: true,
        ...others
    })
}
export function getConfigPrice(success,fail){
    cartAjax({
        path: 'opensale/getconfig',
        success,
        fail
    })
}
export function saveCartInfos(data,success){
    cartAjax({
        path: 'shoppingcart/add',
        data:{
            black_num :data.black,
            orange_num :data.orange,
            blue_num :data.blue,
            hd_num :data.disk,
        },
        success
    })
}
export function affirmCartInfos(data,success){
    cartAjax({
        path: 'shoppingcart/affirm',
        data:{
            black_num :data.black,
            orange_num :data.orange,
            blue_num :data.blue,
            hd_num :data.disk,
        },
        success
    })
}
export function getCartDataFromBackEnd(success,fail){
    cartAjax({
        path: 'shoppingcart/list',
        success,
        fail
    })
}
export function checklogin(success){
    cartAjax({
        path: 'user/checklogin',
        success
    })
}
export function getOriginSelected(){
    if(!localStorage.getItem('cartSelected')){
        return {
            black: true,
            blue: true,
            orange: true,
            disk: true
        }
    }else {
        return JSON.parse(localStorage.getItem('cartSelected')).data;
    }
}
export function getOriginPrice(){
    const price = sessionStorage.getItem('wkyprice');
    return price ? JSON.parse(price) : {
        wky: 599,
        disk: 519,
        discount: 0
    };
}
export function defaultCartData(){
    return {
        black: 0,
        blue: 0,
        orange: 0,
        disk: 0
    }
}
export function getOriginData(){
    if(!localStorage.getItem('cartData')){
        return {
            black: 0,
            blue: 0,
            orange: 0,
            disk: 0
        }
    }else {
        return JSON.parse(localStorage.getItem('cartData')).data
    }
}

export function dataCombiner(storage,backend){
    const black = storage.black + backend.black_num;
    const blue = storage.blue + backend.blue_num;
    const orange = storage.orange + backend.orange_num;
    const disk = storage.disk + backend.hd_num;

    return {
        black: black,
        blue: blue,
        orange: orange,
        disk: disk
    }
}

export function shoppingCartDelete({black,blue,orange}){
    const numbers = getOriginData()
    const newNumbers = {
        black: black ? 0 : numbers.black,
        blue: blue ? 0 : numbers.blue,
        orange: orange ? 0 : numbers.orange,
        disk: 0
    }
    syncData(newNumbers)
}

export function addToShoppingCart(data,success,pop){
	const numbers = getOriginData();
	const newNumbers = {
		black: numbers.black + data.black,
		blue: numbers.blue + data.blue,
		orange: numbers.orange + data.orange,
		disk: numbers.disk + data.disk
    }
    if (newNumbers.black + newNumbers.blue + newNumbers.orange > SINGLE_ORDER_MAX_NUM) {
        pop(`超过${SINGLE_ORDER_MAX_NUM}数量限制`)
        return
    }
    syncData(newNumbers, success)
}

export function syncData(numbers, callback){
    saveCartInfos(numbers,(res)=>{
        callback && callback(res)
        if(res.iRet==0||res.iRet==-501){
            myStorageSteItem('cartData', JSON.stringify({data:numbers}))
        }
    })
}

export function makeCartListInNav(numbers){
    const price = getOriginPrice();
    const selected = getOriginSelected();
    const selectedblack = selected.black ? numbers.black : 0;
    const selectedblue = selected.blue ? numbers.blue : 0;
    const selectedorange = selected.orange ? numbers.orange : 0;
    const selectedNumber = selectedblack+selectedblue+selectedorange; //满减数量不包括disk

    return [
        {
            type: 'black',
            name: '玩客云 曜石黑',
            price: price.wky,
            image: '../../images/purchase/oc_pro_1.jpg',
            number: numbers.black
        },
        {
            type: 'blue',
            name: '玩客云 科技蓝',
            price: price.wky,
            image: '../../images/purchase/oc_pro_3.jpg',
            number: numbers.blue
        },
        {
            type: 'orange',
            name: '玩客云 爱马仕橙',
            price: price.wky,
            image: '../../images/purchase/oc_pro_2.jpg',
            number: numbers.orange
        },
        {
            type: 'discount',
            name: '每满599元立减300元',
            // name: '每满599元立减119元',
            price: price.discount,
            number: selectedNumber,
        },
        {
            type: 'disk',
            name: '希捷2TB黑钻移动硬盘',
            price: price.disk,
            image: '../../images/purchase/disk_sml.png',
            number: numbers.disk
        }
    ]
}

export function numFormat(num) {
    var c = (num.toString().indexOf ('.') !== -1) ? num.toLocaleString() : num.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    return c;
}

export function myStorageSteItem(key,newValue){
    var event = $.Event( "setItemEvent" );
    event.newValue = newValue;
    event.key = key;
    $(window).trigger(event)
    localStorage.setItem(key,newValue);
}


// WEBPACK FOOTER //
// ./js/src/pages/ShoppingCart/util.js